import React from 'react';
import { Link } from 'react-router-dom';
import FETCH from '../Fetch';
import { toast } from './Notifier';
import CourseDetailsLoader from '../loaderComponents/CourseDetailsLoader';

class CourseDetails extends React.Component {
  state = {
    courseDetails: null,
    loading: true
  };

  componentDidMount() {
    const {
      match: { params }
    } = this.props;

    FETCH.getCourseDetails(params.courseId).then(res => {
      if (res.status === 'error') {
        toast(
          res.message
            ? res.message
            : 'Server could not be reached, check network connectivity',
          { status: 'error', timeout: 3600 }
        );
        return this.setState({
          error: true,
          message: res.message,
          loading: false
        });
      }
      this.setState({
        courseDetails: res.data,
        loading: false
      });
    });
  }

  render() {
    const { loading, courseDetails } = this.state;
    return (
      <main className="main-content-area col col-12 col-xs-9 col-sm-8 col-md-9 col-lg-10 col-xl-10">
        <Link to="/courses/registered">
          <h1 className="small">
            <i className="fas fa-arrow-left" />
            Registered Courses
          </h1>
        </Link>
        {/* card for registered courses display  */}
        {loading ? (
          <CourseDetailsLoader />
        ) : (
          <div className="row no-gutters">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-header">
                  <div className="row no-gutters">
                    <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 p-2">
                      About Course
                    </div>
                  </div>
                </div>
                <div className="card-body min-h-700">
                  <div className="row p-60">
                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 p-0 m-0">
                      <h1>{courseDetails.course_title}</h1>
                      <div className="row">
                        <div className="col-xs-12 col-sm-5 col-md-5 col-lg-5">
                          <div className="description-title">Course Code</div>
                          <p className="description-text">
                            {courseDetails.course_code}
                          </p>
                        </div>
                        <div className="col-xs-12 col-sm-5 col-md-5 col-lg-5">
                          <div className="description-title">Course Unit</div>
                          <p className="description-text">
                            {courseDetails.course_unit}
                          </p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-xs-12 col-sm-5 col-md-5 col-lg-5">
                          <div className="description-title">Lecturer</div>
                          <p className="description-text">
                            {courseDetails.lecturer_name}
                          </p>
                        </div>
                        <div className="col-xs-12 col-sm-5 col-md-5 col-lg-5">
                          <div className="description-title">Course Status</div>
                          <p className="description-text">
                            {courseDetails.course_status}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 ">
                      <div className="description-title">
                        Course Description
                      </div>
                      <div className="brief-heading">Overview</div>
                      <p>{courseDetails.course_description}</p>
                      {/* <p>
                        
                      </p> */}
                      {courseDetails.course_guide_url ? (
                        <div className="link-container">
                          <i className="fa fa-download" aria-hidden="true" />
                          <a
                            href={courseDetails.course_guide_url}
                            target="_blank"
                            rel="no_referrer"
                            className="course-brief-download-link"
                          >
                            Download Course Guide
                          </a>
                        </div>
                      ) : (
                        ''
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* card for outstanding fees */}
            </div>
          </div>
        )}
        {/* end card for news display   */}
      </main>
    );
  }
}

export default CourseDetails;
